import dispatcher from 'dispatcher';
import Api from 'utils/api';
import * as actionConstants from 'utils/ActionConstants';

export const verifyToken = async token => {
    return await Api.verifyToken(token);
};



// WEBPACK FOOTER //
// ./src/modules/email-verification/EmailVerificationActions.js